import React from 'react';
import MaskedInput from 'react-text-mask';

const CustomInputField = (props) => {
    const {
        input,
        placeholder,
        type,
        mask,
        meta: { touched, error },
        submitted,
        style,
        autoFocus,
        'data-cy': dataCy,
        inputClassName,
        className,
    } = props;

    if (mask) {
        return (
            <div className={`form__form-group-input-wrap ${className}`}>
                <MaskedInput
                    {...input}
                    placeholder={placeholder}
                    type={type}
                    mask={mask}
                    disabled={submitted}
                    data-cy={dataCy}
                    className={`custom-input ${inputClassName}`}
                />
                {touched && error && (
                    <span
                        className="form__form-group-error"
                        data-cy={`${dataCy}--error`}
                    >
                        {error}
                    </span>
                )}
            </div>
        );
    }

    return (
        <div className={`form__form-group-input-wrap ${className}`}>
            <input
                {...input}
                placeholder={placeholder}
                type={type}
                style={style}
                disabled={submitted}
                autoFocus={autoFocus}
                data-cy={dataCy}
                className={`custom-input ${inputClassName}`}
            />
            {touched && error && (
                <span
                    className="form__form-group-error"
                    data-cy={`${dataCy}--error`}
                >
                    {error}
                </span>
            )}
        </div>
    );
};

export default CustomInputField;
